import React, { useEffect, useContext } from 'react'
import {
    Container,
} from "reactstrap"

import { withRouter } from 'react-router-dom'
import Form from './components/Form'
import { GeneralContext } from '../../context/'

const Create = () => {
    const generalContext = useContext(GeneralContext)
    const { setBreadcrumb } = generalContext

    useEffect(() => {
        setBreadcrumb({
            icon: '',
            parent: `Subcategorías`,
            parentLink: '/subcategories',
            item: `Nueva Subcategoría`
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return(
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Form />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(Create)
